<template>
  <div>
    <b-modal
      ref="multi-mrp-modal"
      centered
      no-close-on-backdrop
      no-close-on-esc
      hide-footer
      title="Select MRP"
      size="sm"
      @hidden="closeMultiMrpModal"
    >
      <b-table
        ref="selectedTable"
        selected-variant="active"
        :items="multiMrp"
        :fields="field"
        class="cash-mangement-table"
        selectable
        select-mode="single"
        @row-selected="selectedMrp"
      >
        <template v-slot:cell(#)="data">
          <p class="mb-0">{{ data.index + 1 }}.</p>
        </template>
        <template v-slot:cell(mrp)="data">
          <p class="mb-0" v-text="currencySymbol + formatAmount(data.item)" />
        </template>
        <template v-slot:cell(radiobtn)="data">
          <div class="custom-check mt-2">
            <input
              type="checkbox"
              disabled
              class="mb-0"
              name="mrp"
              :checked="data.item == parseFloat(selMrp)"
              :id="data.index + 1"
            />
            <label :for="data.index + 1" class="pl-0"></label>
          </div>
        </template>
      </b-table>
      <div style="float: right">
        <b-button
          class="btn btn-primary"
          @click="checkProductInCart"
          v-shortkey="['enter']"
          @shortkey="checkProductInCart"
          :disabled="
            selMrp == undefined || selMrp == '' || selMrp == null || $loading
          "
          id="multiple-mrp-add-to-cart"
        >
          <span v-if="!$loading">Add to cart</span>
          <b-spinner small v-if="$loading" />
        </b-button>
      </div>
    </b-modal>
    <update-qty-modal
      :open="openBox"
      :data="productDetails"
      @close-modal="boxClose"
      :pluQty="pluQty"
      :toCart="true"
    />
  </div>
</template>

<script>
import { mapState } from "vuex";
import UpdateQtyModal from "./UpdateQtyModal";
import * as msg from "../message";
export default {
  name: "multiple-mrp-modal",
  props: ["multipleMrp", "prod", "pluQty"],
  components: { UpdateQtyModal },
  computed: {
    ...mapState({
      state: (state) => state,
    }),
  },
  data() {
    return {
      multiMrp: [],
      selMrp: "",
      openBox: false,
      productDetails: "",
      field: [
        { key: "#", label: "", class: "w-10" },
        { key: "mrp", label: "" },
        { key: "radiobtn", label: "", class: "w-10 p-0" },
      ],
    };
  },
  watch: {
    multipleMrp() {
      if (this.multipleMrp == true) {
        this.openMultipleMrp();
      }
    },
  },

  methods: {
    checkProductInCart() {
      if (
        this.selMrp == undefined ||
        this.selMrp == null ||
        this.selMrp == "" ||
        this.$loading == true
      ) {
        return;
      }
      if (this.prod.weight_flag) {
        this.addToCart();
        return;
      }
      let existsItem = this.state.billing.billing.cart.data.filter((item) => {
        return (
          item.product_data.barcode == this.prod.barcode &&
          item.product_data.unit_mrp == this.selMrp
        );
      });
      if (existsItem.length == 0) {
        this.addToCart();
      } else {
        console.log(
          existsItem[0].product_data.barcode + " " + existsItem[0].qty
        );
        if (
          parseInt(existsItem[0].qty) ==
          parseInt(this.state.system.settings.cart.product_max_qty)
        ) {
          console.log("max qty reached");
          let alertData = {
            message: msg.MAX_PRODUCT_QTY,
            type: "danger",
          };
          this.closeMultiMrpModal();
          this.$store.commit("notifications/showAlert", alertData);
          this.$showAlert = true;
        } else {
          this.addToCart();
        }
      }
    },
    selectedMrp(item) {
      this.selMrp = item[0];
    },
    closeMultiMrpModal() {
      this.$refs["multi-mrp-modal"].hide();
      this.$emit("close-multiple", false);
    },
    openMultipleMrp() {
      this.selMrp = this.prod.mrp;
      this.multiMrp = this.prod.multiple_price;
      this.$refs["multi-mrp-modal"].show();
    },
    addToCart() {
      if (this.prod.weight_flag) {
        this.productDetails = Object.assign(this.prod, {
          change_mrp: this.selMrp,
        });
        this.openBox = true;
        if (typeof Android !== "undefined" && Android !== null) {
          let postData = { type: "read_weight", data: "" };
          returnValue(postData);
        }
        this.closeMultiMrpModal();
      } else {
        this.$loading = true;
        let productData = {
          barcode: this.prod.barcode,
          scan: "TRUE",
          url: "product-details",
          qty: "",
          change_mrp: this.selMrp,
          batch_id: "0",
          serial_id: "0",
          cust_gstin: this.state.billing.billing.customer.data.hasOwnProperty(
            "gstin"
          )
            ? this.state.billing.billing.customer.data.gstin
            : "",
        };
        let data = Object.assign(productData, this.customerData);
        this.$store
          .dispatch("billing/addToCart", data)
          .then(() => {
            this.$store.dispatch("billing/cartDetails").then(() => {
              this.$loading = false;
              this.closeMultiMrpModal();
            });
          })
          .catch((err) => {
            this.$loading = false;
            if (err.hasOwnProperty("status")) {
              if (err.status == "customer_not_tag") {
                let alertData = {
                  message: err.message,
                  type: "danger",
                };
                this.$showAlert = true;
                this.$store.commit("notifications/showAlert", alertData);
              }
            } else {
              if (err.response.data.status == "product_not_found") {
                let alertData = {
                  message: err.response.data.message,
                  type: "danger",
                };
                this.$showAlert = true;
                this.$store.commit("notifications/showAlert", alertData);
              }
              if (err.response.data.status == "fail") {
                let alertData = {
                  message: err.response.data.message,
                  type: "danger",
                };
                this.$showAlert = true;

                this.$store.commit("notifications/showAlert", alertData);
              }
            }
            this.closeMultiMrpModal();
            // this.$bvModal.msgBoxOk(err.response.data.message);
          });
      }
    },
    boxClose(data) {
      this.$emit("clear-plu-qty");
      this.openBox = data;
    },
  },
};
</script>

<style>
.custom-check {
  padding-top: 13px;
}
</style>
